import { Pipe, PipeTransform } from '@angular/core';
import { LegalCounselService } from '../legal-counsel/legal-counsel.service';
import { switchMap , map } from 'rxjs/operators';
import { LegalCounsel } from '../legal-counsel/legal-counsel.dto';
import { Observable } from 'rxjs';

@Pipe({
  name: 'asyncLegalCounselEntity'
})
export class AsyncLegalCounselEntityPipe implements PipeTransform {
  constructor(private legalCounselService: LegalCounselService) {}

  transform(input: number) {
    return this.legalCounselService
    .getAll() 
    .pipe(
      map(entities => entities.find(v => v.id === Number(input))),
      switchMap((lc: LegalCounsel | undefined) => {
        if (!lc) {
          return this.legalCounselService.getLegalCounselById(input);
        } else {
          return new Observable<LegalCounsel>(subscriber => {
            subscriber.next(lc);
            subscriber.complete();
          });
        }
      })
    );
  }

}
